import { NavigationContainerRef, StackActions } from '@react-navigation/native'
import * as React from 'react'

export const navigationRef = React.createRef<NavigationContainerRef>()

function navigate(name: string, params?: object) {
  navigationRef.current?.navigate(name, params)
}

function push(name: string, params?: object) {
  navigationRef.current?.dispatch(StackActions.push(name, params))
}

function back(count?: number) {
  navigationRef.current?.dispatch(StackActions.pop(count))
}

function popToTop() {
  navigationRef.current?.dispatch(StackActions.popToTop())
}

function reset(key: string, routeNames: string[], routes: any) {
  navigationRef.current?.reset({ key, routeNames, routes })
}

export const useNav = () => ({
  navigate,
  push,
  back,
  popToTop,
  reset,
})
